// extracted by mini-css-extract-plugin
module.exports = {"root":"Param_root__3CS8B","valueCheck":"Param_valueCheck__1tCGB","valueCross":"Param_valueCross__zgKc-"};